import Visual1 from "../../img/screenshots/scratchmap/scratchmap-feature-01.png";
import Visual2 from "../../img/screenshots/scratchmap/scratchmap-feature-02.png";
import Visual3 from "../../img/screenshots/scratchmap/scratchmap-feature-03.png";
import Visual4 from "../../img/screenshots/scratchmap/scratchmap-feature-04.png";

export const ScratchMapFeatureContent = [
  {
    title: "Build your very own online scratch map",
    subtitle: "Add the countries you’ve visited",
    text: "Keep track of your adventures in style! Start your scratch map by adding all the countries you've visited. Watch the map change as you “scratch” off each destination—your travels, beautifully visualized.",
    image: Visual1,
  },
  {
    title: "Level up your scratch map with your travel wishlist",
    subtitle: "Add countries on your bucket list",
    text: "Got big travel dreams? Elevate your map by adding the places on your travel bucket list. Each scratch reveals not only where you’ve been, but where your wanderlust is taking you next. Scratch today, explore tomorrow!",
    image: Visual2,
  },
  {
    title: "Use themes to personalise your scratch map",
    subtitle: "Customise your map",
    text: `Choose from a variety of colours and map styles to personalise and "glow up" your online scratch map.`,
    image: Visual4,
  },
  {
    title: "From the wall to your feed",
    subtitle: "Share your online scratch maps",
    text: "Your scratch map, but make it digital! Share your map across social media and let your travel community know where you’ve been and where you're headed. From your screen to theirs, it’s the perfect way to inspire wanderlust.",
    image: Visual3,
  },
];
